export const RESET_SESSION_MODAL_TEST_ID = 'reset-session-modal';
